import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Linker from '@/components/base/Linker';
import Logo from './Logo';
import { gettext } from '@/utils/langsBook';
import { makeHomeLink } from '@/utils/link';
import { DEFAULT } from '@/constants';
var Footer = function() {
    return(/*#__PURE__*/ _jsx("footer", {
        className: "border-t-[1px] border-base container-min-w",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto h-[112px] flex items-center justify-between container-w",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ _jsx(Linker, {
                            href: makeHomeLink(),
                            children: /*#__PURE__*/ _jsx(Logo, {
                                textClass: "!text-[16px]"
                            })
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "ml-[42px] hover:text-primary",
                            children: /*#__PURE__*/ _jsx(Linker, {
                                className: "text-base",
                                href: "https://docs.dioxide.network",
                                target: "_blank",
                                children: gettext('Doc')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "justify-end text-[14px] text-desc",
                    children: [
                        "\xa9 2024 ",
                        DEFAULT.NET,
                        " Dev Team"
                    ]
                })
            ]
        })
    }));
};
export default Footer;
